<script setup lang="ts">
import { useCmsBlock } from "#imports";
import type { Schemas } from "#shopware";

type CmsBlockMsbBlogBlock = Schemas["CmsBlock"] & {
  type: "msb-blog-block";
  slot: string;
};

const props = defineProps<{
  content: CmsBlockMsbBlogBlock;
}>();
// netzp-blog6
const { getSlotContent } = useCmsBlock(props.content);
const slotContent = getSlotContent("content");
</script>

<template>
  <CmsGenericElement :content="slotContent" />
</template>


